import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';
import UserControls from 'flarum/forum/utils/UserControls';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import MentorPage from './components/MentorPage';
import MentorCenterPage from './components/MentorCenterPage';
import MentorBindingRequestedNotification from './components/MentorBindingRequestedNotification';
import MentorBindingApprovedNotification from './components/MentorBindingApprovedNotification';
import MentorBindingRejectedNotification from './components/MentorBindingRejectedNotification';
import MentorBindingTerminatedNotification from './components/MentorBindingTerminatedNotification';
import MentorGraduatedNotification from './components/MentorGraduatedNotification';

app.initializers.add('taro-mentor', () => {
  // ── 通知组件注册 ──
  app.notificationComponents.mentorBindingRequested = MentorBindingRequestedNotification;
  app.notificationComponents.mentorBindingApproved = MentorBindingApprovedNotification;
  app.notificationComponents.mentorBindingRejected = MentorBindingRejectedNotification;
  app.notificationComponents.mentorBindingTerminated = MentorBindingTerminatedNotification;
  app.notificationComponents.mentorGraduated = MentorGraduatedNotification;

  // ── 用户子页面路由（渲染在个人主页右侧内容区）──
  app.routes['user.taroMentors'] = { path: '/u/:username/mentors', component: MentorPage };
  // 保留旧版独立路由作为别名（兼容已有链接）
  app.routes['taro.mentors.page'] = { path: '/taro/mentors', component: MentorPage };

  // ── 导师中心独立路由 ──
  app.routes['taro.mentor.center'] = { path: '/mentor-center', component: MentorCenterPage };

  // ── 登录提醒：未绑定导师时提示（仅登录用户）──
  if (app.session?.user) {
    const api = app.forum.attribute('apiUrl');
    app.request({ method: 'GET', url: api + '/taro/mentors/my' }).then((r) => {
      const data = r.data || r;
      if (!data || !data.id) {
        alert('你还未绑定导师，将无法使用导师功能。请前往「师生关系」页面绑定导师。');
      }
    }).catch(() => {});
  }

  // ── 侧边导航栏：考试中心（含导航栏入口）──
  extend(IndexPage.prototype, 'navItems', function(items) {
    items.add('taroMentorCenter', LinkButton.component({
      href: app.route('taro.mentor.center'),
      icon: 'fas fa-chalkboard-teacher'
    }, '导师中心'), 68);
  });

  // ── 个人主页侧边栏导航：师生关系 ──
  extend(UserPage.prototype, 'navItems', function(items) {
    const user = this.user;
    if (!user) return;

    const isActor = app.session.user === user;
    if (!isActor) return;

    items.add('taroMentors', LinkButton.component({
      href: app.route('user.taroMentors', { username: user.slug() }),
      icon: 'fas fa-chalkboard-teacher'
    }, '师生关系'), 70);
  });

  // ── 个人主页卡片控制按钮（UserControls）──
  extend(UserControls, 'controls', function(ctrlItems, user) {
    if (app.session.user && app.session.user.id() === user.id()) {
      const isMentor = !!user.attribute('taroIsMentor');
      ctrlItems.add('taroMentors', LinkButton.component({
        href: app.route('user.taroMentors', { username: user.slug() }),
        icon: 'fas fa-chalkboard-teacher'
      }, isMentor ? '师生关系' : '师生关系'));
    }
  });
});
